import { render, staticRenderFns } from "./profileFriendsChat.vue?vue&type=template&id=84c9f192&scoped=true&"
import script from "./profileFriendsChat.vue?vue&type=script&lang=js&"
export * from "./profileFriendsChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9f192",
  null
  
)

export default component.exports